<div class="row p-0">
  <div class="card p-0">
    <div class="bg-light p-2">
      <div class="row align-items-center">
        <div class="col-12 col-md-3">
            <label for="from_date" class="pb-2">{{ "From Date" | translate }}</label>
            <input
              type="text"
              id="from_date"
              placeholder="Datepicker"
              class="form-control"
              bsDatepicker
              [bsValue]="bsValue"
              [daysDisabled]="[6, 0]"
              [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"
            />
          </div>
    
        <div class="col-12 col-md-3">
          <label for="to_date" class="pb-2">{{ "To Date" | translate }}</label>
          <input
            type="text"
            id="to_date"
            placeholder="Datepicker"
            class="form-control"
            bsDatepicker
            [bsValue]="bsValue"
            [daysDisabled]="[6, 0]"
            [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"
          />
        </div>
        <div class="col-12 col-md-3">
          <label for="status" class="pb-2">{{
            "Select Status" | translate
          }}</label>
          <select class="form-select taskspanel" id="status">
            <option value="0" class="select_options">Select</option>
            <option value="unassigned" class="select_options">Approved</option>
            <option value="assigned" class="select_options">Rejected</option>
            <option value="started" class="select_options">Not Approved</option>
          </select>
        </div>
      </div>
    </div>
    <div class="card-body common_scroller fixed_height p-0">
<div class="container-fluid mt-2">
    <table class="table table-bordered">
        <thead>
            <tr>
              <th class="single-line">Employee Id</th>
              <th class="single-line">Name</th>
              <th class="single-line">Adhoc Type</th>
              <th class="single-line">Roster Date</th>
              <th class="single-line">Login Time</th>
              <th class="single-line">Logout Time</th>
              <th class="single-line">Updation Type</th>
              <th class="single-line">Reason</th>
              <th class="single-line">Action</th>
            </tr>
          </thead>
          
       
      <tbody>
        <tr *ngFor="let record of employeeRecords">
          <td>{{ record.employeeId }}</td>
          <td>{{ record.name }}</td>
          <td>{{ record.adhocType }}</td>
          <td>{{ record.rosterDate }}</td>
          <td>{{ record.loginTime }}</td>
          <td>{{ record.logoutTime }}</td>
          <td>{{ record.updationType }}</td>
          <td>{{record.reason}}</td>
          <td>
            <div class="d-inline-flex justify-content-center align-items-center">
                <div class="badge btn approved-btn ">Approve</div>
                <div class="badge btn btn-danger ms-1" style="width: 70px;">Reject</div>
              </div>       
           
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  
    </div>
  </div>
</div>
